import { render } from "./AddTransfertPointVente.vue?vue&type=template&id=4760b440&scoped=true&ts=true"
import script from "./AddTransfertPointVente.vue?vue&type=script&lang=ts"
export * from "./AddTransfertPointVente.vue?vue&type=script&lang=ts"

import "./AddTransfertPointVente.vue?vue&type=style&index=0&id=4760b440&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4760b440"]])

export default __exports__